module.exports = __webpack_public_path__ + "ef0b31c4937a29d3af4806ad116ea9a4.pdf";